import { render, staticRenderFns } from "./iplimited.vue?vue&type=template&id=77abd0ad&scoped=true&"
import script from "./iplimited.vue?vue&type=script&lang=js&"
export * from "./iplimited.vue?vue&type=script&lang=js&"
import style0 from "./iplimited.vue?vue&type=style&index=0&id=77abd0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77abd0ad",
  null
  
)

export default component.exports